import { Component, Input, inject, Output, OnInit, input } from '@angular/core';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '../../api/models';
import { TableComponent } from '@app/shared/components/table/table.component';
import { CommonModule } from '@angular/common';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { TableColumn } from '@app/shared/components/table/table.component';
import { Pagination } from '@app/shared/model';
import { BolsaPagamentoService } from '../../api/services';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';

@Component({
  standalone: true,
  selector: 'app-lista-dado-financeiro',
  imports: [
    SearchBarComponent,
    TableComponent,
    CommonModule,
    DataVoidComponent,
    DialogModule, SelectModule, Button, InputText, ReactiveFormsModule,
  ],
  providers: [
    BolsaPagamentoService
  ],
  templateUrl: './lista-dado-financeiro.component.html',
  styleUrl: './lista-dado-financeiro.component.scss'
})
export class ListaDadoFinanceiroComponent implements OnInit {
  @Input() bolseiroID!: string;
  bolseiro = input<any>();
  pagination: Pagination<any> = new Pagination<any>();
  bolsaPagamento = inject(BolsaPagamentoService);
  route = inject(ActivatedRoute);
  form!: FormGroup;

  tipoBolsaOptions: any[] = [
    { id: 1, label: 'Interna' },
    { id: 2, label: 'Externa' },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'periodo',
      placeholder: 'Período',
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'tipoBolsa',
      placeholder: 'Tipo de auxílio',
      options: this.tipoBolsaOptions,
      optionLabel: 'label',
      optionValue: 'id',
    }
  ];

  columns: TableColumn[] = [
    {
      field: 'dataPagamentoFormatada',
      header: 'Data de Pagamento',
      type: 'text',
      tooltip: 'Data de Pagamento',
    },
    {
      field: 'tipoBolsaDescricao',
      header: 'Período',
      type: 'text',
      tooltip: 'Período',
    },
    {
      field: 'nivelAcademicoDescricao',
      header: 'Ano Lectivo',
      type: 'text',
      tooltip: 'Ano Lectivo',
    },
    {
      field: 'nivelAcademicoDescricao',
      header: 'Ano Curricular',
      type: 'text',
      tooltip: 'Ano Curricular',
    },
    {
      field: 'pagamento.valorTotal',
      header: 'Valor Pago',
      type: 'text',
      tooltip: 'Valor Pago',
    },
  ];

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.bolseiroID = this.route.snapshot.paramMap.get('id')!;
    // this.getBolsaPagamento(this.bolseiroID);
    this.form = this.fb.group({
      periodo: [null],
      tipoBolsa: [null],
    });
  }

  getBolsaPagamento(bolseiroID: string) {
    this.bolsaPagamento.show(bolseiroID).subscribe(
      (response: any) => {
        this.pagination = new Pagination<any>().deserialize(response);
        console.log("Pagamentos do Bolseiro", this.pagination);
      },
      (error: any) => {
        console.error('Erro ao buscar pagamentos do bolseiro:', error);
      }
    );
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.showFilter = false;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
  }
}
